import { ReportHandler, Metric } from 'web-vitals';

function sendToAnalytics(metric: Metric) {
  if (process.env.NODE_ENV === 'development') {
    console.debug(`[web-vitals] ${metric.name}`, Math.round(metric.value), metric.id);
  }
  // Hook for production RUM (GA4, Datadog, etc.)
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('d88-web-vital', { detail: metric }));
  }
}

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  const handler = onPerfEntry || sendToAnalytics;
  if (handler && handler instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(handler);
      getFID(handler);
      getFCP(handler);
      getLCP(handler);
      getTTFB(handler);
    });
  }
};

export default reportWebVitals;
